<template>
  <div class="box-second ptoTotal">
    <div class="box-head">
      <div class="head-name">项目统计</div>
      <div class="head-num">
        <el-menu class="el-menu-demo" mode="horizontal" background-color="#F5F5F5" active-text-color="#000"
          @select="selectFun">
          <el-submenu index="1">
            <template slot="title">
              <p @click="showStatus('')">
                项目总数
                <span style="color:#36C635;margin-left:10px;">{{ num.all }}</span>
              </p>
            </template>
            <el-menu-item index="1-1" class="total-item">
              房建
              <span style="color:#FFBC01;margin-left:10px;">{{ num.sjfj.fj }}</span>
            </el-menu-item>
            <el-menu-item index="1-2" class="total-item">
              市政
              <span style="color:#FFBC01;margin-left:10px;">{{ num.sjfj.sj }}</span>
            </el-menu-item>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title">
              <p @click="showStatus(2)">
                <img src="../../assets/image/pro_build1.png" style="width:2vh;height:2vh;" />
                在建
                <span style="color:#36C635;margin-left:10px;">{{ num.zj.zjxm }}</span>
              </p>
            </template>
            <el-menu-item index="2-1" class="total-item">
              房建
              <span style="color:#FFBC01;margin-left:10px;">{{ num.zj.zjfj }}</span>
            </el-menu-item>
            <el-menu-item index="2-2" class="total-item">
              市政
              <span style="color:#FFBC01;margin-left:10px;">{{ num.zj.zjsz }}</span>
            </el-menu-item>
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">
              <p @click="showStatus(3)">
                <img src="../../assets/image/pro_finsh1.png" style="width:2vh;height:2vh;" />
                竣工
                <span style="color:#36C635;margin-left:10px;">{{ num.jg.jgxm }}</span>
              </p>
            </template>
            <el-menu-item index="3-1" class="total-item">
              房建
              <span style="color:#FFBC01;margin-left:10px;">{{ num.jg.jgfj }}</span>
            </el-menu-item>
            <el-menu-item index="3-2" class="total-item">
              市政
              <span style="color:#FFBC01;margin-left:10px;">{{ num.jg.jgsz }}</span>
            </el-menu-item>
          </el-submenu>
          <!-- <el-submenu index="4">
            <template slot="title">
              <p @click="showStatus(4)">
                <img src="../../assets/image/pro_stop1.png" style="width:2vh;height:2vh;" />
                停工
                <span style="color:#36C635;margin-left:10px;">{{num.tg.tgxm}}</span>
              </p>
            </template>
            <el-menu-item index="4-1" class="total-item">
              房建
              <span style="color:#FFBC01;margin-left:10px;">{{num.tg.tgfj}}</span>
            </el-menu-item>
            <el-menu-item index="4-2" class="total-item">
              市政
              <span style="color:#FFBC01;margin-left:10px;">{{num.tg.tgsz}}</span>
            </el-menu-item>
          </el-submenu> -->
        </el-menu>
      </div>
      <div class="head-search1 demo-input-suffix" style="background:#ffff;">
        <el-select v-model="search.projectName" filterable clearable popper-class="fen-sel" class="fen-val"
          placeholder="选择检索项目" @change="doFilter">
          <el-option v-for="item in projects" :key="item.id" :label="item.name" :value="item.name"></el-option>
        </el-select>
      </div>
      <el-button type="primary" v-if="isExit" plain size="mini" style="margin-left: 1vw;font-size:0.9vw;"
        @click="addProject">添加项目</el-button>
    </div>
    <div class="box-main">
      <div class="box-main-left">
        <baidu-map :center="center" id="xjMap" :zoom="zoom" @ready="handler" style="height:100%;width:100%;"
          @click="getClickInfo" :scroll-wheel-zoom="true">
          <!-- <bm-ground style="z-index:-1" :bounds="{ne: {lng: 117.237491, lat: 31.909984}, sw:{lng: 117.026497000, lat: 31.760013000}}" :opacity='0.9' :imageURL="mapURL">
            </bm-ground> -->
          <bm-marker v-for="item in points" @click="clickHandler(item)" :key="item.id" :position="item.position"
            :icon="{ url: item.url, size: { width: item.width, height: item.height } }">
          </bm-marker>
        </baidu-map>
        <!-- <div class="map-tip">
           <img src="../../assets/image/pro_build.png" style="height:2.5vh;" />
           <p style="width:100%;position: relative;text-align: center;margin-bottom: 1vh;">在建</p>
           <img src="../../assets/image/pro_stop.png"  style="height:2.5vh;" />
           <p style="width:100%;position: relative;text-align: center;margin-bottom: 1vh;">停工</p>
           <img src="../../assets/image/pro_finsh.png"  style="height:2.5vh;" />
           <p style="width:100%;position: relative;text-align: center;">竣工</p>
        </div> -->
      </div>
      <div class="box-table">
        <div class="box-table-item" v-if="item.projectStatus !== '3' && groupId == '1240117140208402434'" v-for="item in listData"
          :key="item.id">
          <div style="width:100%;display:flex;align-items:center">
            <div class="nowrap" :title="item.name">{{ item.name }}</div>
          </div>
          <div style="width:100%;display:flex;align-items: center">
            <div style="width:90%;display:flex;flex-wrap:wrap;position: relative;">
              <div style="width:100%;display:flex;position: relative;">
                <div style="width:10vw;text-align: left;color:#36C635;">合同工期：{{ item.allDay }}天</div>
                <div style="flex:1;padding:0 20px;" class="progress2">
                  <el-progress :text-inside="true" :stroke-width="32" :format="_formatRate(item.progressVal, item)"
                    :percentage="parseFloat(item.progress) > 100 ? 100 : parseFloat(item.progress)"
                    color="#2740E6"></el-progress>
                </div>
              </div>
              <!-- <div style="width:100%;display:flex;position: relative;margin-top: 1vh;">
                <div style="width:10vw;color:#36C635;text-align: left;">进度产值：{{item.settlementTotal}}万元</div>
                <div style="flex:1;padding:0 20px;" class="progress2">
                  <el-progress
                    :text-inside="true"
                    :stroke-width="16"
                    :format="_formatRate(item.settleProgress)"
                    :percentage="parseFloat(item.settleProgress)>100?100:parseFloat(item.settleProgress)"
                    color="#36C635"
                  ></el-progress>
                </div>
              </div> -->
            </div>
            <div v-if="port == '5' || port == '3'" style="width:10%;padding-right:30px;text-align: right;"
              @click="updataFun(item)">
              <i class="el-icon-edit-outline" style="font-size:30px;color:#5f74f9;font-weight: bold;cursor: pointer;"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div style="width:100%;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalItems"
        style="padding-top:10px;"
      ></el-pagination>
    </div> -->
    <!-- 新增窗口 -->
    <el-dialog title="新增项目" :visible.sync="addVisible" center :append-to-body="true" :lock-scroll="false" class="add-form"
      width="30vw">
      <el-form :model="addForm" ref="addForm" label-width="120px" label-position="right" :rules="rules">
        <el-form-item label="项目名称：" prop="projectName">
          <el-input v-model="addForm.projectName" autocomplete="off" placeholder="请输入项目名称"></el-input>
        </el-form-item>
        <el-form-item label="施工许可证：" prop="permit">
          <el-input v-model="addForm.permit" autocomplete="off" placeholder="请输入施工许可证"></el-input>
        </el-form-item>
        <el-form-item label="管理员姓名：" prop="managerPerson" style="width:100%;">
          <el-input v-model="addForm.managerPerson" autocomplete="off" placeholder="请输入管理员姓名"></el-input>
        </el-form-item>
        <el-form-item label="账号：" prop="managerPhone" style="width:100%;" required>
          <el-input v-model="addForm.managerPhone" autocomplete="off" placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item label="企业组织：" style="width:100%;">
          <el-select v-model="addForm.officeId" clearable filterable placeholder="请选择">
            <el-option v-for="item in offices" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="参建单位：" prop="joinType" style="width:100%;" required>
          <el-select v-model="addForm.joinType" clearable filterable placeholder="请选择">
            <el-option v-for="item in joinTypes" :key="item.id" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注：" style="width:100%;">
          <p style="color:#F56C6C;">新用户的默认密码是手机号码。</p>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改 -->
    <el-dialog title="修改项目" :visible.sync="modVisible" center :append-to-body="true" :lock-scroll="false" class="add-form"
      width="30vw">
      <el-form :model="addForm" ref="addForm" label-width="120px" label-position="right" :rules="rules">
        <el-form-item label="项目名称：">
          <span>{{ addForm.projectName }}</span>
        </el-form-item>
        <!-- <el-form-item label="管理员姓名：" style="width:100%;">
          <span>{{addForm.managerPerson}}</span>
        </el-form-item>
        <el-form-item label="账号：" style="width:100%;" required>
          <span>{{addForm.managerPhone}}</span>
        </el-form-item> -->
        <el-form-item label="企业组织：" style="width:100%;">
          <el-select v-model="addForm.officeId" clearable filterable placeholder="请选择">
            <el-option v-for="item in offices" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="modVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbitModRow">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base';
export default {
  data() {
    //手机号验证
    var validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号码！'));
      } else if (!(/^1[3456789]\d{9}$/.test(value))) {
        callback(new Error('手机号码格式错误！'));
      } else {
        callback();
      }
    };
    return {
      groupId: '',
      search: {

        projectName: '',
        name: '',
        ent: '',
        pageNum: 0,
        pageSize: 0,
        projectStatus: '', //1拟建，2在建，3竣工，4停建
        projectType: '', //1房屋建筑工程，2市政公用工程
        joinType: ''
      },
      projects: [],
      listData: [],
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      num: {
        all: 0,
        jg: { jgfj: 0, jgsz: 0, jgxm: 0 },
        zj: { zjfj: 0, zjsz: 0, zjxm: 0 },
        tg: { tgfj: 0, tjsz: 0, tgxm: 0 },
        sjfj: { fj: 0, sj: 0 }
      },
      addForm: {
        projectName: '',
        managerPerson: '',
        managerPhone: '',
        managerPswd: '',
        entId: '',
        officeId: '',
        joinType: '',
        permit: '',
      },
      addVisible: false,//弹出框展示判断
      //添加弹出输入框验证
      rules: {
        projectName: [
          { required: true, message: '请输入项目名称', trigger: 'blur' }
        ],
        managerPerson: [
          { required: true, message: '请输入管理员姓名', trigger: 'blur' }
        ],
        managerPhone: [
          { validator: validatePhone, trigger: 'blur' }
        ],
        managerPswd: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        joinType: [
          { required: true, message: '请选择参建单位类型', trigger: 'blur' }
        ],
        permit: [
          { required: true, message: '请输入施工许可证', trigger: 'blur' }
        ],
      },
      //地图中心
      center: {
        lng: 117.129186,
        lat: 31.836603
      },
      zoom: 13,
      points: [],
      offices: [],
      port: '',
      modVisible: false,
      joinTypes: [],
      mapURL: '',

      isExit: false,//展示添加
    }
  },
  watch: {
    '$store.state.groupId': function (val, old) {
      this.groupId = util.session.get('groupId')
      this.addForm.entId = this.groupId
      this.getNum()
      this.getData()
      this.getAll()
      this.getRelevanceList()
    }
  },
  mounted() {
    this.groupId = this.$store.state.groupId
    if ('' == this.groupId || undefined == this.groupId) {
      this.groupId = util.session.get('groupId')
    }
    if (this.groupId == '1263382107619520513') {
      this.mapURL = 'http://47.100.89.71:18004/static/wisdom/wechat/map/6.jpg'
      this.isExit = false
    } else {
      this.mapURL = ''
      this.isExit = true
    }
    this.search.joinType = util.session.get('roleId') == '3' ? '3' : ''
    this.port = util.session.get('roleId')
    this.addForm.entId = this.groupId
    util.session.remove('backPage')
    this.getNum()
    // this.getData()
    this.getAll()
    this.getJoinTypeList()
  },
  methods: {
    // 搜索数据
    doFilter() {
      this.currentPage = 1
      this.getData()
      this.getRelevanceList()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
      this.getRelevanceList()
    },
    //获取数据
    getData() {
      var that = this
      this.search.entId = this.groupId
      this.search.pageNum = 1
      this.search.pageSize = 10000
      myHttp
        .getProjectPageListByEntIdAndJoinType(this.search)
        .then(function (resp) {
          console.log('老列表---》', resp)
          // if (resp.data.code == '200') {
          //   var list = resp.data.data.pageInfo.list || []
          //   for (var i = 0; i < list.length; i++) {
          //     list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
          //     var now = util.myTime.getCurTime()
          //     list[i].restDay = util.myTime.getdayByDate(list[i].startDate,now)
          //     if (list[i].allDay == 0) {
          //       list[i].progress = 0
          //     } else {
          //       list[i].progress = (
          //         (parseInt(list[i].restDay) /
          //           parseInt(list[i].allDay)) *
          //         100
          //       ).toFixed(2)
          //     }
          //       if (list[i].settlementTotal == 0 ||list[i].settlementValue == 0) {
          //       list[i].settleProgress = 0
          //     } else {
          //       list[i].settleProgress = (
          //         ((parseInt(list[i].settlementValue)) / parseInt(list[i].settlementTotal)) * 100
          //       ).toFixed(2)
          //     }
          //     list[i].progressVal = JSON.parse(JSON.stringify(list[i].progress))
          //     list[i].progress = parseFloat(list[i].progress)
          //     list[i].settleProgress = parseFloat(list[i].settleProgress)
          //     list[i].cumulativeComplete = list[i].cumulativeComplete  ? parseFloat(list[i].cumulativeComplete): 0
          //     // console.log( list)
          //     // console.log( list[i].progress)
          //   }
          //   that.listData = list

          //   //  console.log(  that.listData)
          //   //if(that.totalItems==0){
          //   that.totalItems = resp.data.data.pageInfo.total
          //   //}
          //   that.showMarker(list)
          // }
        })
    },
    //获取所有项目
    getAll() {
      var that = this
      myHttp
        .getProjectListByEntIdAndJoinType({
          entId: this.groupId,
          // joinType: this.search.joinType
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.list || []
            // that.projects = list
          }
        })
    },
    //获取项目统计
    getNum() {
      var that = this
      myHttp
        .getListEnterpriseAndJoinType({
          entId: this.groupId,
          joinType: this.search.joinType,
          projectType: this.search.projectType
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            that.num = resp.data.data ? resp.data.data : that.num
          }
        })
    },
    //跳转详情
    toproject(row) {
      util.session.set('proId', row.id)
      util.session.set('backPage', '4')
      var that = this
      setTimeout(function () {
        that.$router.push({ path: '/attendTeamCom' })
      }, 0)
    },
    //统计菜单激活回调
    selectFun(index, path) {
      // console.log(index, path)
      if (index == '1-1') {
        this.search.projectStatus = ''
        this.search.projectType = '1'
      } else if (index == '1-2') {
        this.search.projectStatus = ''
        this.search.projectType = '2'
      } else if (index == '2-1') {
        this.search.projectStatus = '2'
        this.search.projectType = '1'
      } else if (index == '2-2') {
        this.search.projectStatus = '2'
        this.search.projectType = '2'
      } else if (index == '3-1') {
        this.search.projectStatus = '3'
        this.search.projectType = '1'
      } else if (index == '3-2') {
        this.search.projectStatus = '3'
        this.search.projectType = '2'
      } else if (index == '4-1') {
        this.search.projectStatus = '4'
        this.search.projectType = '1'
      } else if (index == '4-2') {
        this.search.projectStatus = '4'
        this.search.projectType = '2'
      }
      this.currentPage = 1
      this.getData()
      this.getRelevanceList()
    },
    showStatus(index) {
      this.search.projectStatus = index
      this.search.projectType = ''
      this.currentPage = 1
      this.getData()
      this.getRelevanceList()
    },
    //添加项目方法
    addProject() {
      this.addForm.projectName = ''
      this.addForm.managerPerson = ''
      this.addForm.managerPhone = ''
      this.addForm.managerPswd = ''
      this.addForm.officeId = ''
      this.addForm.joinType = this.search.joinType
      this.addForm.permit = ''
      this.addVisible = true
      this.getOfficeList()
    },
    //弹出框
    sumbitAddRow(formName) {
      var that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addForm.entId = this.groupId
          this.addForm.personId = util.session.get('user').id
          this.addForm.managerPswd = this.addForm.managerPhone
          this.addForm.type = '2'
          myHttp.addConstructionProject(this.addForm).then(function (resp) {
            if (resp.data.code == '200') {
              that.$message.success('添加成功')
              that.addVisible = false
              that.currentPage = 1
              that.getData()
              that.getRelevanceList()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
        } else {
          return false;
        }
      });
    },

    //获取参建单位类型数据
    getJoinTypeList() {
      var that = this
      myHttp.getDictByType({
        type: 'join_type'
      }).then(function (resp) {
        // console.log(resp)
        if (resp.data.code == '200') {
          var list = resp.data.data.dictList || []
          that.joinTypes = list
        }
      })
    },

    //地图展示
    handler({ BMap, map }) {
      this.map = map
      this.getData()
      this.getRelevanceList()
      // var cityName = '安徽省';
      // map.centerAndZoom(cityName, 11);                     // 初始化地图,设置中心点坐标和地图级别。    map.addControl(new BMap.ScaleControl());                    // 添加比例尺控件
      map.enableScrollWheelZoom();
      // var bdary = new BMap.Boundary();
      // marker.Yc.parentNode.parentNode.style.zIndex = 500;
      var styleJson = [{
        "featureType": "land",
        "elementType": "geometry",
        "stylers": {
          "visibility": "on",
          "color": "#ffffff"
        }
      }, {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": {
          "visibility": "on",
          "color": "#ffffff"
        }
      }, {
        "featureType": "green",
        "elementType": "geometry",
        "stylers": {
          "visibility": "on",
          "color": "#ffffff"
        }
      }, {
        "featureType": "building",
        "elementType": "geometry",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "building",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#ffffff"
        }
      }, {
        "featureType": "building",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#ffffff"
        }
      }, {
        "featureType": "subwaystation",
        "elementType": "geometry",
        "stylers": {
          "visibility": "on",
          "color": "#ffffff"
        }
      }, {
        "featureType": "education",
        "elementType": "geometry",
        "stylers": {
          "visibility": "on",
          "color": "#ffffff"
        }
      }, {
        "featureType": "medical",
        "elementType": "geometry",
        "stylers": {
          "visibility": "on",
          "color": "#ffffff"
        }
      }, {
        "featureType": "scenicspots",
        "elementType": "geometry",
        "stylers": {
          "visibility": "on",
          "color": "#ffffff"
        }
      }, {
        "featureType": "highway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "on",
          "weight": 4
        }
      }, {
        "featureType": "highway",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#ffffff"
        }
      }, {
        "featureType": "highway",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#ffffff"
        }
      }, {
        "featureType": "highway",
        "elementType": "labels",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "highway",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#ffffff"
        }
      }, {
        "featureType": "highway",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff"
        }
      }, {
        "featureType": "highway",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "arterial",
        "elementType": "geometry",
        "stylers": {
          "visibility": "on",
          "weight": 2
        }
      }, {
        "featureType": "arterial",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#ffffff"
        }
      }, {
        "featureType": "arterial",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#ffffff"
        }
      }, {
        "featureType": "arterial",
        "elementType": "labels",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "arterial",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#ffffff"
        }
      }, {
        "featureType": "arterial",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffffff"
        }
      }, {
        "featureType": "local",
        "elementType": "geometry",
        "stylers": {
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "local",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#ffffffff"
        }
      }, {
        "featureType": "local",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#ffffffff"
        }
      }, {
        "featureType": "local",
        "elementType": "labels",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "local",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#ffffffff"
        }
      }, {
        "featureType": "local",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffffff"
        }
      }, {
        "featureType": "railway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "railway",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#ffffffff"
        }
      }, {
        "featureType": "railway",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#ffffffff"
        }
      }, {
        "featureType": "subway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "subway",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#ffffffff"
        }
      }, {
        "featureType": "subway",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#ffffffff"
        }
      }, {
        "featureType": "subway",
        "elementType": "labels",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "subway",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#ffffffff"
        }
      }, {
        "featureType": "subway",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffffff"
        }
      }, {
        "featureType": "continent",
        "elementType": "labels",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "continent",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "continent",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#ffffffff"
        }
      }, {
        "featureType": "continent",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffffff"
        }
      }, {
        "featureType": "city",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "city",
        "elementType": "labels",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "city",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#ffffffff"
        }
      }, {
        "featureType": "city",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffffff"
        }
      }, {
        "featureType": "town",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "town",
        "elementType": "labels",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "town",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#ffffffff"
        }
      }, {
        "featureType": "town",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffffff"
        }
      }, {
        "featureType": "road",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#ffffffff " //  #12223dff
        }
      }, {
        "featureType": "poilabel",
        "elementType": "labels",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "districtlabel",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "road",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "road",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#ffffffff"
        }
      }, {
        "featureType": "district",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "poilabel",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "poilabel",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#ffffffff"
        }
      }, {
        "featureType": "poilabel",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffffff"
        }
      }, {
        "featureType": "manmade",
        "elementType": "geometry",
        "stylers": {
          "color": "#ffffffff"
        }
      }, {
        "featureType": "districtlabel",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffffff"
        }
      }, {
        "featureType": "entertainment",
        "elementType": "geometry",
        "stylers": {
          "color": "#ffffffff"
        }
      }, {
        "featureType": "shopping",
        "elementType": "geometry",
        "stylers": {
          "color": "#ffffffff"
        }
      }];
      var that = this
      setTimeout(function () {
        if (that.groupId == '1263382107619520513') {
          map.setMapStyle({ styleJson: styleJson });
        }
      }, 500)
    },
    //地图点击方法
    getClickInfo(e) {
      // console.log(e)
      if (!this.curIndex) {
        var allOverlay = this.map.getOverlays();
        for (var i = 0; i < allOverlay.length; i++) {
          if (allOverlay[i].toString() == "[object Overlay]") {
            this.map.removeOverlay(allOverlay[i]);
          }
        }
      }
      this.infoWindowClose()
    },
    //展示地图标记
    showMarker(list) {
      var points = [];
      var viewPoints = []
      for (var i = 0; i < list.length; i++) {
        if (list[i].gpsPoint && '' != list[i].gpsPoint) {
          var obj = list[i]
          var position = list[i].gpsPoint.split(',')
          obj.position = { lng: position[0], lat: position[1] }
          obj.typeName = list[i].projectType == '1' ? '房建' : '市政'

          if (list[i].allDay) {
            var readDay = parseInt(list[i].allDay) - parseInt(list[i].otherDay)
            obj.progress = ((readDay / list[i].allDay) * 100).toFixed(2)
          } else {
            obj.progress = 0
          }

          if (obj.projectStatus == '2') {
            obj.url = require('../../assets/image/pro_build.gif')
            obj.width = 60,
              obj.height = 60
          } else if (obj.projectStatus == '3') {
            obj.url = require('../../assets/image/pro_build.gif')
            obj.width = 60,
              obj.height = 60
          } else if (obj.projectStatus == '4') {
            obj.url = require('../../assets/image/pro_build.gif')
            obj.width = 60,
              obj.height = 60
          }
          points.push(obj)
          viewPoints.push(new BMap.Point(obj.position.lng, obj.position.lat))

        }
      }
      // console.log(points)
      // this.center = points.length>0?points[0].position:this.center
      this.points = points
      //设置地图视野zoon和中心点
      var view = this.map.getViewport(eval(viewPoints));

      if (this.groupId != '1263382107619520513') {
        // this.zoom = 5
        this.center = view.center
        var that = this
        setTimeout(function () {
          that.map.setViewport(viewPoints)
        }, 100)
      }
      setTimeout(function () {
        var pointBg = document.getElementsByClassName('BMap_Marker')
        for (var i = 0; i < pointBg.length; i++) {
          if (pointBg[i].className == 'BMap_Marker') {
            pointBg[i].parentNode.style.zIndex = 500
          }
        }
      }, 1000)
    },
    //点击方法
    clickHandler(e) {
      this.curIndex = e
      this.showMapMarker(e)
    },
    //关闭
    infoWindowClose() {
      this.curIndex = undefined
    },
    //查看
    clear(row) {
      util.session.set('proId', row.id)
      util.session.set('backPage', '6')
      var that = this
      setTimeout(function () {
        that.$router.push({ path: '/entProInfo' })
      }, 0)
    },

    //展示地图数据
    showMapMarker(obj) {
      var _selt = this
      // 复杂的自定义覆盖物
      function ComplexCustomOverlay(point, obj) {
        this._point = point;
        this._option = obj
      }
      ComplexCustomOverlay.prototype = new BMap.Overlay();
      ComplexCustomOverlay.prototype.initialize = function (map) {
        this._map = map;
        var option = this._option;
        var div = this._div = document.createElement("div");
        div.style.position = "absolute";
        // div.style.zIndex = BMap.Overlay.getZIndex(this._point.lat);
        div.style.zIndex = 500;
        div.style.height = "300px";
        div.style.width = "240px";
        div.style.background = "rgba(19, 46, 140, 0.8)";
        div.style.borderRadius = "5px";
        div.style.padding = "10px";
        div.style.cursor = 'pointer'
        var that = this;

        //图片
        var imgDiv = document.createElement("img");
        imgDiv.style.position = "relative";
        imgDiv.style.width = "220px";
        imgDiv.style.height = "150px";
        imgDiv.style.marginBottom = "20px";
        var imgs = option.photoPath.split(',')
        var img = ''
        for (var i = 0; i < imgs.length; i++) {
          if (imgs[i] != '') {
            img = base.httpCtx + imgs[i]
          }
        }
        if (img == '') {
          imgDiv.src = require('../../assets/image/zanwutupian.png')
        } else {
          imgDiv.src = img
        }
        div.appendChild(imgDiv);

        //项目名称
        var nameText = document.createElement("p");
        nameText.style.position = "relative";
        nameText.style.width = "100%";
        nameText.style.height = "30px";
        nameText.style.fontSize = "14px";
        nameText.style.color = "rgba(255, 255, 255, 1)";
        nameText.style.whiteSpace = "nowrap";
        nameText.style.textOverflow = "ellipsis";
        nameText.style.overflow = "hidden";
        nameText.innerHTML = option.name || '';
        nameText.title = option.name || '';
        div.appendChild(nameText);

        //项目位置
        var addrText = document.createElement("p");
        addrText.style.position = "relative";
        addrText.style.width = "100%";
        addrText.style.height = "30px";
        addrText.style.fontSize = "12px";
        addrText.style.color = "rgba(255, 255, 255, 1)";
        addrText.style.whiteSpace = "nowrap";
        addrText.style.textOverflow = "ellipsis";
        addrText.style.overflow = "hidden";
        addrText.title = option.address || '';
        addrText.innerHTML = '项目位置：' + option.address;
        div.appendChild(addrText);

        //投资进度
        // var progressText = document.createElement("p");
        // progressText.style.position = "relative";
        // progressText.style.width = "100%";
        // progressText.style.height = "30px";
        // progressText.style.fontSize = "12px";
        // progressText.style.color = "rgba(255, 255, 255, 1)";
        // progressText.innerHTML = '投资进度：'+(option.cumulativeComplete||0)+'%'+', 金额：'+(option.price||0)+'万';
        // div.appendChild(progressText);

        //工期
        var dateText = document.createElement("p");
        dateText.style.position = "relative";
        dateText.style.width = "100%";
        dateText.style.height = "30px";
        dateText.style.fontSize = "12px";
        dateText.style.color = "rgba(255, 255, 255, 1)";
        dateText.innerHTML = '工期：' + option.allDay + '天, 剩余：' + option.otherDay + '天（' + option.progress + '%）';
        div.appendChild(dateText);

        div.onclick = function () {
          // util.session.set('proId', option.id)
          // util.session.set('backPage', '4')
          // //var that = this
          // setTimeout(function() {
          //     _selt.$router.push({ path: '/attendTeamCom' })
          // }, 0)
        }

        map.getPanes().labelPane.appendChild(div);

        return div;
      }
      ComplexCustomOverlay.prototype.draw = function () {
        var map = this._map;
        var pixel = map.pointToOverlayPixel(this._point);
        this._div.style.left = (pixel.x + 20) + 'px';
        this._div.style.top = pixel.y + 'px';
      }
      var allOverlay = this.map.getOverlays();
      for (var i = 0; i < allOverlay.length; i++) {
        if (allOverlay[i].toString() == "[object Overlay]") {
          this.map.removeOverlay(allOverlay[i]);
        }
      }
      var gpsLi = obj.gpsPoint.split(",");
      var myCompOverlay = new ComplexCustomOverlay(new BMap.Point(gpsLi[0], gpsLi[1]), obj);
      this.map.addOverlay(myCompOverlay);

    },
    /**
     * 获取企业组织架构
     */
    getOfficeList() {
      var that = this
      myHttp.getOfficeList({
        entId: this.groupId
      }).then(function (resp) {
        //console.log(resp)
        if (resp.data.code == '200') {
          var list = resp.data.data.officeList || []
          that.offices = list
        }
      })
    },
    /**
     * 修改
     */
    updataFun(row) {
      // console.log(row)
      var that = this
      myHttp.editEntOfficeProjectInformation({
        entId: this.groupId,
        projectId: row.id
      }).then(function (resp) {
        //console.log(resp)
        if (resp.data.code == '200') {
          var data = resp.data.data
          that.addForm.projectName = data.projectName
          that.addForm.projectId = data.projectId
          that.addForm.officeId = data.officeId || ''
          that.modVisible = true
          that.getOfficeList()
        }
      })
    },

    /**
     * 修改
     */
    sumbitModRow() {
      var that = this
      myHttp.editEntOfficeProject({
        officeId: that.addForm.officeId,
        entId: this.groupId,
        projectId: this.addForm.projectId
      }).then(function (resp) {
        if (resp.data.code == '200') {
          that.$message.success('添加成功')
          that.modVisible = false
        } else {
          that.$message.error(resp.data.msg)
        }
      })
    },

    /**
     * 
     */
    _formatRate(value, item) {
      console.log('============' + item.name + '================' + value)
      return () => {
        return value + '%'
      }
    },
    // 获取新的项目列表
    async getRelevanceList() {
      this.search.entId = this.groupId
      this.search.pageNum = 1
      this.search.pageSize = 10000
      const that = this
      const resp = await myHttp.getRelevanceList(
        this.search
      )
      if (resp.data.code == 200) {
        console.log(resp);

        var list = resp.data.data.list || []
        if (!this.search.projectName || this.search.projectName == '') { that.projects = list }
        for (var i = 0; i < list.length; i++) {
          list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
          var now = util.myTime.getCurTime()
          list[i].restDay = util.myTime.getdayByDate(list[i].startDate, now)
          if (list[i].allDay == 0) {
            list[i].progress = 0
          } else {
            list[i].progress = (
              (parseInt(list[i].restDay) /
                parseInt(list[i].allDay)) *
              100
            ).toFixed(2)
          }
          if (list[i].settlementTotal == 0 || list[i].settlementValue == 0) {
            list[i].settleProgress = 0
          } else {
            list[i].settleProgress = (
              ((parseInt(list[i].settlementValue)) / parseInt(list[i].settlementTotal)) * 100
            ).toFixed(2)
          }
          list[i].progressVal = JSON.parse(JSON.stringify(list[i].progress))
          list[i].progress = parseFloat(list[i].progress)
          list[i].settleProgress = parseFloat(list[i].settleProgress)
          list[i].cumulativeComplete = list[i].cumulativeComplete ? parseFloat(list[i].cumulativeComplete) : 0
          // console.log( list)
          // console.log( list[i].progress)
        }
        that.listData = list

        //  console.log(  that.listData)
        //if(that.totalItems==0){
        that.totalItems = resp.data.data.total
        //}
        that.showMarker(list)
      }
      // console.log('新的项目列表---》',data);
    }
  }
}
</script>
<style scoped>
* {
  box-sizing: border-box;
}

.nowrap {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.box-second {
  width: 100%;
  position: relative;
  height: 100%;
  background: #fff;
}

.box-head {
  width: 100%;
  height: 5vh;
  position: relative;
  display: flex;
  padding: 0 1vw;
  background: #f5f5f5;
  align-content: center;
  align-items: center;
}

.head-name {
  display: flex;
  align-items: center;
  color: #6b6b6b;
  font-size: 18px;
}

.head-num {
  flex: 1;
  padding: 0 20px;
  display: flex;
  align-items: center;
}

.head-search1 {
  width: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.box .el-submenu {
  margin-right: 20px;
}

.box .el-submenu p {
  font-size: 0.95vw;
}

.box-main {
  width: 100%;
  height: calc(100% - 5vh);
  position: relative;
  display: flex;
  background: #EEEFF8;
}

.box-main-left {
  width: 60%;
  height: 100%;
  position: relative;
  padding: 1vh;
}

.box-table {
  width: 40%;
  height: 100%;
  position: relative;
  overflow: auto;
}

.box-table-item {
  width: 100%;
  height: 12vh;
  margin-top: 1.4vh;
  margin-bottom: 1.4vh;
  /* background: #f5f5f5; */
  justify-content: space-between;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* color: #aecfdc; */
  box-sizing: border-box;
  font-size: 18px;
  padding: 20px;
}

.ptoTotal p {
  margin: 0;
}

.map-tip {
  position: absolute;
  top: 2vh;
  right: 2vh;
  width: 6vh;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  justify-items: center;
  background: #fff;
  padding: 1vh 0.5vh;
  box-shadow: 0px 0px 5px 2px #ddd;
  border-radius: 5px;
}
</style>
<style>
.head-num .el-menu--horizontal {
  background: transparent;
  border-bottom: 0;
}

.head-num .el-menu--horizontal>.el-submenu .el-submenu__title {
  height: 40px;
  line-height: 40px;
  border-bottom: 0;
  color: #6b6b6b;
  background: transparent;
  font-size: 18px;
}

.head-num .el-menu--horizontal>.el-submenu .el-submenu__icon-arrow {
  display: none;
}

.el-menu--horizontal .total-item {
  /* background-color: rgb(0, 20, 152); */
  font-size: 16px;
  color: #000 !important;
}

.box-table-item .progress1 .el-progress-bar__outer {
  background-color: #DADEFD;
}

.progress2 .el-progress-bar__outer {
  background-color: #DADEFD;
}

.fen-val .el-input__inner {
  background: transparent;
  border: 0;
  font-size: 16px;
  text-align: right;
  /* color: #fff; */
}

.fen-sel,
.fen-sel .el-select-dropdown__item.hover,
.fen-sel .el-select-dropdown__item:hover {
  /* background: #001498; */
  background: #fff;
  border: 0;
}

.fen-sel .el-select-dropdown__empty,
.fen-sel .el-select-dropdown__item {
  color: #000;
}

.fen-val.el-select .el-input {
  width: 240px;
}

.ptoTotal .el-pagination span {
  color: #000;
}

.ptoTotal .el-pagination .el-input__inner {
  background: transparent;
  color: #000;
}

.ptoTotal .el-menu--horizontal {
  box-shadow: none;
}

.ptoTotal .el-progress-bar__innerText {
  font-size: inherit;
}

.ptoTotal .el-progress-bar__innerText {
  color: #fff;
  text-shadow: 0 0 1px currentColor, -1px -1px 1px #000, 0 -1px 1px #000, 1px -1px 1px #000, 1px 0 1px #000, 1px 1px 1px #000, 0 1px 1px #000, -1px 1px 1px #000, -1px 0 1px #000;
}
</style>